export default "__VITE_ASSET__yYjlj$SI__"